"use client"
import { useUserContext } from "src/lib/contexts/ContextTypes";
import useWatchlist from "src/lib/filmwebid/useWatchlist";
import type { IFilmwebIdMovieIdentifier } from "src/lib/filmwebid/useMovieIdentifier";
import { matchesIdentifier } from "src/lib/filmwebid/useMovieIdentifier";
import { useMemo } from "react";

//#region [Props]
type WithWatchlistStateProps = {
	movieIdentifier?: IFilmwebIdMovieIdentifier | null;
}

//#endregion


//#region [Props]
export interface IWatchlistable {
	isWatchlisted?: boolean;
	onWatchlistClick?: () => void;
}

//#endregion
//#region [Component]
function withWatchlistState<P extends IWatchlistable>(WrappedComponent: React.ComponentType<P>) {

	const EnhancedComponent = (props: WithWatchlistStateProps & Omit<P, "isWatchlisted" | "onWatchlistClick">) => {
		const userContext = useUserContext();
		const [watchlister, isWatchlisting] = useWatchlist({ movieIdentifier: props.movieIdentifier });

		const isWatchlisted = useMemo(() => {
			if (!props.movieIdentifier) return false;
			return userContext.watchlistedList.some(item =>
				item.movieIdentifiers?.some(id => matchesIdentifier(id, props.movieIdentifier!))
			);
		}, [userContext.watchlistedList, props.movieIdentifier]);

		return <WrappedComponent {...props as P} isWatchlisted={isWatchlisted} onWatchlistClick={() => watchlister(!isWatchlisted)} />
	}
	EnhancedComponent.displayName = `WithWatchlistState(${getDisplayName(WrappedComponent)})`;
	return EnhancedComponent;
}

export default withWatchlistState;
//#endregion

//#region [Other]
function getDisplayName<P>(WrappedComponent: React.ComponentType<P>) {
	return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
//#endregion
